import { gql } from "@apollo/client";

const GET_COMMENTS = gql`
  query getComments($postId: ID!) {
    comments(postId: $postId) {
      id
      content
      createdAt
      userId
      postId
      replies {
        id
        content
        createdAt
        userId
        postId
        commentId
      }
    }
  }
`;

const GET_COMMENT = gql`
  query getComment($id: ID!) {
    comment(id: $id) {
      id
      content
      createdAt
      userId
      postId
      replies {
        id
        content
        createdAt
        userId
        postId
        commentId
      }
    }
  }
`;

export { GET_COMMENTS, GET_COMMENT }
